import React from "react";
import "./styles.css";

function AllyCard({ icon, title, audience, description }) {
  return (
    <div className="ally-card">
      <span>{icon}</span>
      <h1>{title}</h1>
      <h2>Dirigido a: {audience}</h2>
      <p>{description}</p>
    </div>
  );
}

export default AllyCard;
